import PropTypes from "prop-types";
import CrossIcon from "../../../assets/icons/svg/CrossIcon.svg";
import RedirectIcon from "../../../assets/icons/svg/Redirect.svg";
import { useTranslation } from "react-i18next";

const ErrorBanner = ({
  onDismiss,
  onReadMore,
  message = "Some File(s) couldn't be uploaded due to errors.",
  showReadMore = true,
}) => {
  const { t } = useTranslation();
  return (
    <div className="bg-[rgba(231,85,85,0.25)] border border-[#E75555] rounded-lg p-3 mb-4 flex items-center justify-between">
      <div className="flex items-center">
        <button onClick={onDismiss} className="flex-shrink-0 focus:outline-none">
          <img src={CrossIcon} alt="Dismiss" className="h-4 w-4" />
        </button>

        <div className="ms-3">
          <p className="text-sm font-medium flex items-center">
            {t(message)}
            {showReadMore && (
              <button onClick={onReadMore} className="flex items-center ms-3">
                <img src={RedirectIcon} alt="Read More" className="h-4 me-2" />
                <span className="font-semibold">{t("Read More")}</span>
              </button>
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

ErrorBanner.propTypes = {
  onDismiss: PropTypes.func.isRequired,
  onReadMore: PropTypes.func,
  message: PropTypes.string,
  showReadMore: PropTypes.bool,
};

export default ErrorBanner;
